import loadView from "@/utils/load-view";

const routes = [
    // Legacy routes
    {
        path: "/reviews/show/templates",
        redirect: "/reviews/templates",
    },
    {
        path: "/reviews/show/admin",
        redirect: "/reviews/cycles",
    },
    {
        path: "/reviews/show",
        redirect: "/reviews",
    },
    {
        path: "/reviews/show/undefined",
        redirect: "/reviews",
    },
    {
        path: "/reviews/create/:entrypoint",
        redirect: "/reviews/templates/create",
    },
    {
        path: "/reviews/createTemplate/:entrypoint",
        redirect: "/reviews/templates/create",
    },
    {
        path: "/reviews/create/:reviewCycleId/:entrypoint",
        redirect: to => `/reviews/cycles/edit/${to.params.reviewCycleId}`,
    },
    {
        path: "/reviews/update/:reviewCycleId/status/:entrypoint",
        redirect: to => `/reviews/cycles/edit/${to.params.reviewCycleId}/status`,
    },

    {
        path: "/reviews",
        redirect: "/reviews/assessments",
        name: "Reviews",
        component: loadView("Reviews"),
        meta: {
            authRequired: true,
            resolvers: [
                () => ({
                    type: "reviews/assessments/getList",
                    payload: { scope: "admin", cache: true },
                }),
            ],
        },
        children: [
            {
                path: "/reviews/assessments",
                name: "ReviewsAssessments",
                component: loadView("ReviewsAssessments"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({ type: "reviews/assessments/getList", payload: { scope: "toDo" } }),
                    ],
                },
            },
            {
                path: "/reviews/shared",
                name: "ReviewsShared",
                component: loadView("ReviewsShared"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({ type: "reviews/assessments/getList", payload: { scope: "toDo" } }),
                    ],
                },
            },
            {
                path: "/reviews/progress",
                name: "ReviewsProgress",
                component: loadView("ReviewsProgress"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({
                            type: "reviews/assessments/getParticipantProgress",
                            payload: {},
                        }),
                    ],
                },
            },
            {
                path: "/reviews/templates",
                name: "ReviewsTemplates",
                component: loadView("ReviewsTemplates"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({
                            type: "reviews/assessments/getList",
                            payload: { scope: "admin" },
                        }),
                    ],
                },
            },
            {
                path: "/reviews/automations",
                name: "ReviewsAutomations",
                component: loadView("ReviewsAutomations"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "reviews/automations/getList" })],
                },
                children: [
                    {
                        path: "/reviews/automations/create",
                        name: "ReviewsAutomationsCreate",
                        component: loadView("ReviewsAutomationsCreate"),
                        meta: {
                            authRequired: true,
                            resolvers: [
                                () => ({
                                    type: "reviews/assessments/getList",
                                    payload: { scope: "admin" },
                                }),
                            ],
                        },
                    },
                    {
                        path: "/reviews/automations/edit/:id",
                        name: "ReviewsAutomationsEdit",
                        component: loadView("ReviewsAutomationsEdit"),
                        props: true,
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [
                                to => ({
                                    type: "reviews/automations/getDetails",
                                    payload: { id: to.params.id },
                                }),
                                to => ({
                                    type: "reviews/automations/getPreview",
                                    payload: { id: to.params.id },
                                }),
                            ],
                        },
                    },
                ],
            },
            {
                path: "/reviews/cycles",
                name: "ReviewsCycles",
                component: loadView("ReviewsCycles"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({
                            type: "reviews/assessments/getList",
                            payload: { scope: "admin" },
                        }),
                        () => ({ type: "reviews/automations/getList" }),
                    ],
                },
            },
            {
                path: "/reviews/analytics",
                redirect: "/reviews/analytics/heatmap",
            },
            {
                path: "/reviews/analytics/:view",
                name: "ReviewsAnalytics",
                component: loadView("ReviewsAnalytics"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({
                            type: "teams/local/getList",
                            payload: { filter: "all", cache: true },
                        }),
                        () => ({
                            type: "users/customAttribute/getList",
                            payload: { cache: true },
                        }),
                    ],
                },
            },
        ],
    },
    {
        path:
            "/reviews/update/:reviewCycleId/reviewee/:revieweeId/:role/:contributorId/viewAs/:viewAs/:view/:entrypoint",
        name: "ReviewsUpdate",
        component: loadView("ReviewsUpdate"),
        props: true,
        meta: {
            authRequired: true,
            resolvers: [
                to => ({
                    type: "reviews/participants/getStatus",
                    payload: {
                        reviewCycleId: to.params.reviewCycleId,
                        revieweeId: to.params.revieweeId,
                        role: to.params.role,
                        contributorId: to.params.contributorId,
                        viewAs: to.params.viewAs,
                        view: to.params.view,
                        entrypoint: to.params.entrypoint,
                    },
                }),
                () => ({ type: "teams/local/getList", payload: { filter: "manager" } }),
                () => ({ type: "teams/customrole/getList" }),
            ],
        },
        children: [
            {
                path:
                    "/reviews/update/:reviewCycleId/reviewee/:revieweeId/:role/:contributorId/viewAs/:viewAs/:view/:entrypoint/feedback/details/:id",
                name: "ReviewsUpdateFeedbackDetails",
                component: loadView("FeedbackDetails"),
                props: true,
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [
                        () => ({
                            type: "feedback/feedback/getList",
                            payload: { filter: "my" },
                        }),
                        to => ({
                            type: "feedback/feedback/getDetails",
                            payload: { id: to.params.id },
                        }),
                        to => ({
                            type: "feedback/feedback/read",
                            payload: { id: to.params.id },
                        }),
                    ],
                },
            },
        ],
    },
    {
        path: "/reviews/templates/create",
        name: "ReviewsTemplatesCreate",
        component: loadView("ReviewsTemplatesCreate"),
        meta: {
            authRequired: true,
        },
    },
    {
        path: "/reviews/templates/edit/:id",
        redirect: to => `/reviews/templates/edit/${to.params.id}/basics`,
        name: "ReviewsTemplatesEdit",
        component: loadView("ReviewsTemplatesEdit"),
        props: true,
        meta: {
            authRequired: true,
            resolvers: [
                to => ({
                    type: "reviews/templates/get",
                    payload: { id: to.params.id },
                }),
            ],
        },
        children: [
            {
                path: "/reviews/templates/edit/:id/basics",
                props: true,
                name: "ReviewsTemplatesEditBasics",
                component: loadView("ReviewsTemplatesEditBasics"),
                meta: {
                    authRequired: true,
                    resolvers: [],
                },
            },
            {
                path: "/reviews/templates/edit/:id/scope",
                props: true,
                name: "ReviewsTemplatesEditScope",
                component: loadView("ReviewsTemplatesEditScope"),
                meta: {
                    authRequired: true,
                    resolvers: [],
                },
            },
            {
                path: "/reviews/templates/edit/:id/questions",
                props: true,
                name: "ReviewsTemplatesEditQuestions",
                component: loadView("ReviewsTemplatesEditQuestions"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "skills/getSkills", payload: { showAll: true } })],
                },
                children: [
                    {
                        path: "/reviews/templates/edit/:id/questions/preview/:role/:userId",
                        props: true,
                        name: "ReviewsTemplatesEditQuestionsPreview",
                        component: loadView("ReviewsTemplatesEditQuestionsPreview"),
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [
                                to => ({
                                    type: "reviews/templates/preview",
                                    payload: {
                                        id: to.params.id,
                                        role: to.params.role,
                                        userId: to.params.userId,
                                    },
                                }),
                            ],
                        },
                    },
                ],
            },
            {
                path: "/reviews/templates/edit/:id/visibility",
                props: true,
                name: "ReviewsTemplatesEditVisibility",
                component: loadView("ReviewsTemplatesEditVisibility"),
                meta: {
                    authRequired: true,
                    resolvers: [],
                },
            },
            {
                path: "/reviews/templates/edit/:id/timeline",
                props: true,
                name: "ReviewsTemplatesEditTimeline",
                component: loadView("ReviewsTemplatesEditTimeline"),
                meta: {
                    authRequired: true,
                    resolvers: [],
                },
            },
            {
                path: "/reviews/templates/edit/:id/notifications",
                props: true,
                name: "ReviewsTemplatesEditNotifications",
                component: loadView("ReviewsTemplatesEditNotifications"),
                meta: {
                    authRequired: true,
                    resolvers: [],
                },
            },
            {
                path: "/reviews/templates/edit/:id/confirm",
                props: true,
                name: "ReviewsTemplatesEditConfirm",
                component: loadView("ReviewsTemplatesEditConfirm"),
                meta: {
                    authRequired: true,
                    resolvers: [],
                },
            },
        ],
    },
    {
        path: "/reviews/cycles/edit/:id",
        name: "ReviewsCyclesEdit",
        component: loadView("ReviewsCyclesEdit"),
        props: true,
        meta: {
            authRequired: true,
            resolvers: [
                to => ({
                    type: "reviews/cycles/get",
                    payload: { id: to.params.id },
                }),
            ],
        },
        children: [
            {
                path: "/reviews/cycles/edit/:id/status",
                props: true,
                name: "ReviewsCyclesEditStatus",
                component: loadView("ReviewsCyclesEditStatus"),
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => ({
                            type: "reviews/participants/getList",
                            payload: { id: to.params.id },
                        }),
                        () => ({
                            type: "teams/local/getList",
                            payload: {},
                        }),
                    ],
                },
                children: [
                    {
                        path: "/reviews/cycles/edit/:id/status/participant/add",
                        props: true,
                        name: "ReviewsCyclesEditStatusParticipantAdd",
                        component: loadView("ReviewsCyclesEditStatusParticipantAdd"),
                        meta: {
                            authRequired: true,
                            modal: true,
                        },
                    },
                    {
                        path: "/reviews/cycles/edit/:id/status/participant/edit/:userId",
                        props: true,
                        name: "ReviewsCyclesEditStatusParticipantEdit",
                        component: loadView("ReviewsCyclesEditStatusParticipantEdit"),
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [
                                to => ({
                                    type: "reviews/participants/getList",
                                    payload: {
                                        id: to.params.id,
                                        fullname: "",
                                        localTeam: "all",
                                        manager: "all",
                                        status: "all",
                                        page: 0,
                                        cache: true,
                                    },
                                }),
                            ],
                        },
                    },
                ],
            },
            {
                path: "/reviews/cycles/edit/:id/basics",
                props: true,
                name: "ReviewsCyclesEditBasics",
                component: loadView("ReviewsCyclesEditBasics"),
                meta: {
                    authRequired: true,
                    resolvers: [],
                },
            },
            {
                path: "/reviews/cycles/edit/:id/participants",
                props: true,
                name: "ReviewsCyclesEditParticipants",
                component: loadView("ReviewsCyclesEditParticipants"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "users/location/getList" })],
                },
            },
            {
                path: "/reviews/cycles/edit/:id/scope",
                props: true,
                name: "ReviewsCyclesEditScope",
                component: loadView("ReviewsCyclesEditScope"),
                meta: {
                    authRequired: true,
                    resolvers: [],
                },
            },
            {
                path: "/reviews/cycles/edit/:id/questions",
                props: true,
                name: "ReviewsCyclesEditQuestions",
                component: loadView("ReviewsCyclesEditQuestions"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "skills/getSkills", payload: { showAll: true } })],
                },
                children: [
                    {
                        path: "/reviews/cycles/edit/:id/questions/preview/:role/:userId",
                        props: true,
                        name: "ReviewsCyclesEditQuestionsPreview",
                        component: loadView("ReviewsTemplatesEditQuestionsPreview"),
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [
                                to => ({
                                    type: "reviews/templates/preview",
                                    payload: {
                                        id: to.params.id,
                                        role: to.params.role,
                                        userId: to.params.userId,
                                    },
                                }),
                            ],
                        },
                    },
                ],
            },
            {
                path: "/reviews/cycles/edit/:id/visibility",
                props: true,
                name: "ReviewsCyclesEditVisibility",
                component: loadView("ReviewsCyclesEditVisibility"),
                meta: {
                    authRequired: true,
                    resolvers: [],
                },
            },
            {
                path: "/reviews/cycles/edit/:id/timeline",
                props: true,
                name: "ReviewsCyclesEditTimeline",
                component: loadView("ReviewsCyclesEditTimeline"),
                meta: {
                    authRequired: true,
                    resolvers: [],
                },
            },
            {
                path: "/reviews/cycles/edit/:id/notifications",
                props: true,
                name: "ReviewsCyclesEditNotifications",
                component: loadView("ReviewsCyclesEditNotifications"),
                meta: {
                    authRequired: true,
                    resolvers: [],
                },
            },
            {
                path: "/reviews/cycles/edit/:id/confirm",
                props: true,
                name: "ReviewsCyclesEditConfirm",
                component: loadView("ReviewsCyclesEditConfirm"),
                meta: {
                    authRequired: true,
                    resolvers: [],
                },
            },
        ],
    },
];

export default routes;
